import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import useForm from '../../CustomHooks/FormHook'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'
import { enterKeyHandler } from '../../../utils'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import TextInput from '../TextInput'
import '../Custom.css'

export default function PlaintiffUpdateForm({ location }) {
  console.log('PlaintiffUpdateForm rendered: ', location)

  let init = {
    plaintiffFirstName: '',
    plaintiffLastName: '',
    claimName: '',
  }
  const navigate = useNavigate()
  init = initialFormValues('PlaintiffUpdateForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  async function submitSearch() {
    submitFormValues('PlaintiffUpdateForm', navigate, inputs, 'mrg.plaintiff_update')
  }

  return (
    <div className="custom-scroll">
      <form onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText='Plaintiff Update' />
            <tbody>
              <TextInput label='First Name' name='plaintiffFirstName' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffFirstName} />
              <TextInput label='Last Name' name='plaintiffLastName' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffLastName} />
              <TextInput label='Case Name' name='claimName' handleInputChange={handleInputChange} defaultValue={inputs.claimName} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label='Search' />
      </form>
    </div>
  )
}
